import {camelCase as lodashCamelCase, capitalize} from 'lodash-es'

export function capsCase (string) {
  return capitalize(string)
}

export function camelCase (string) {
  return lodashCamelCase(string)
}
